import React from "react";
import { Icon } from "./Icon";

export function Input({ icon, invalid = false, disabled = false, style = {}, onFocus, onBlur, ...rest }) {
  const [focus, setFocus] = React.useState(false);
  return (
    <div style={{ position: "relative", width: "100%" }}>
      {icon && (
        <Icon name={icon} size={16} style={{
          position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)",
          color: "var(--text-muted)", pointerEvents: "none",
        }} />
      )}
      <input
        disabled={disabled}
        // Taken out of `rest` so the spread below cannot replace these and
        // leave the focus ring on after the field is left (T21-M2).
        onFocus={(e) => { setFocus(true); onFocus?.(e); }}
        onBlur={(e) => { setFocus(false); onBlur?.(e); }}
        style={{
          width: "100%", padding: "11px 16px", paddingLeft: icon ? 36 : 16,
          fontFamily: "var(--font-body)", fontSize: "var(--text-base)",
          color: "var(--text-body)", background: disabled ? "var(--surface-muted)" : "var(--surface-raised)",
          border: `1.5px solid ${invalid ? "var(--danger)" : focus ? "var(--hive)" : "var(--border-default)"}`,
          borderRadius: "var(--radius-sm)", outline: "none",
          boxShadow: focus ? (invalid ? "0 0 0 4px rgba(163,51,42,.18)" : "var(--shadow-focus-input)") : "none",
          transition: "border-color var(--duration-fast) var(--ease-out), box-shadow var(--duration-fast) var(--ease-out)",
          opacity: disabled ? 0.6 : 1,
          ...style,
        }}
        {...rest}
      />
    </div>
  );
}
